import routes from '../constants/routes'

export const navigateToApp = ({ history, targetPath } = {}) => {
  history.push(targetPath ?? routes.HOME)
}
